
























import InputField from "../../core/Forms/InputField.vue";

interface Theme {
    name: string;
    value: string;
    color1: string;
    color2: string;
    color3: string;
}

export default {
    name: "ColorSelector",
    components: { InputField },
    props: {
        value: String,
    },
    data() {
        return {
            themes: [
                {
                    name: "Theme A",
                    value: "theme-a",
                    color1: "bg-info",
                    color2: "bg-info-light",
                    color3: "bg-white",
                },
                {
                    name: "Theme B",
                    value: "theme-b",
                    color1: "bg-green",
                    color2: "bg-green-light",
                    color3: "bg-white",
                },
                {
                    name: "Theme C",
                    value: "theme-c",
                    color1: "bg-purple",
                    color2: "bg-purple-light",
                    color3: "bg-white",
                },
                {
                    name: "Theme D",
                    value: "theme-d",
                    color1: "bg-danger",
                    color2: "bg-danger-light",
                    color3: "bg-white",
                },
                {
                    name: "Theme E",
                    value: "theme-e",
                    color1: "bg-info",
                    color2: "bg-info-light",
                    color3: "bg-gray-dark",
                },
                {
                    name: "Theme F",
                    value: "theme-f",
                    color1: "bg-green",
                    color2: "bg-green-light",
                    color3: "bg-gray-dark",
                },
                {
                    name: "Theme G",
                    value: "theme-g",
                    color1: "bg-purple",
                    color2: "bg-purple-light",
                    color3: "bg-gray-dark",
                },
                {
                    name: "Theme H",
                    value: "theme-h",
                    color1: "bg-danger",
                    color2: "bg-danger-light",
                    color3: "bg-gray-dark",
                },
            ] as Array<Theme>,
            selectedTheme: null,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.selectedTheme = this.value;
            },
        },
        selectedTheme: {
            handler: function () {
                this.$emit("input", this.selectedTheme);
                localStorage.removeItem("ngStorage-layout");
            },
        },
    },
};
